import { Observable } from 'rxjs';
import { UserInfo } from '../state/user/user-info';
import { InjectionToken } from '@angular/core';

export const AUTH_SERVICE = new InjectionToken<IAuthService>('AuthService');

export interface IAuthService {
  login(state: string): void;

  checkSession(): boolean;

  getToken(): Observable<{
    state: string | undefined;
    validToken: boolean;
  }>;

  getUserInfo(): Observable<UserInfo>;

  getAccessToken(): string | null;

  logout(): void;

  isTokenExpired(): boolean;

  refresh(): void;

  getSchema(): string;

  setOAuthConfiguration(company: string): void;

  forceLogout(): void;

  sessionExpired(): void;

  tokenEndpoint(): string | undefined;

  isSesExpired(): boolean;
  tokenTimeChanged(): void;
  checkInitialSession(): void;
}
